import type { CreditNoteStatus } from "@/features/credit-notes/types";

export const CN_STATUSES: { value: CreditNoteStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "issued", label: "Issued" },
  { value: "cancelled", label: "Cancelled" },
];

export function labelFor(
  options: { value: string; label: string }[],
  value: string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function statusTone(status: CreditNoteStatus): "success" | "warning" | "danger" | "neutral" {
  switch (status) {
    case "issued":
      return "success";
    case "cancelled":
      return "danger";
    default:
      return "neutral";
  }
}

export function canEditLines(status: CreditNoteStatus) {
  return status === "draft";
}
